<template>
<div class="container">

<div class="form" style="margin-bottom:0;">

<div class="row">
	<hos @select="haha" :isbook="1"></hos>	
</div>


<div class="row">
	<div class="col-3 left" style="letter-spacing:0;">体检单位</div>
	<div class="col-7">
		<mt-field placeholder="请输入体检单位" v-model="f.com"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">姓&nbsp;&nbsp;名</div>
	<div class="col-7">
		<mt-field placeholder="请输入姓名" v-model="f.name"></mt-field>
	</div>
</div>

</div>  <!-- endform -->

<div class="row pd">
	<mt-button type="primary" size="large" @click="search">开始查询</mt-button>
</div>

<div class="myitem" v-for="v in re" v-if="re.length>0">
	<div class="row bb">
	<span v-show="!v.tjsj">可预约</span>
	<span v-show="v.tjsj" class="gray">已预约</span>
	</div>
	<div class="row">
		<div class="col-3">合同名称</div>
		<div class="col-7">{{v.htmc}}</div>
	</div>
	<div class="row pb">
		<div class="col-3">套餐名称</div>
		<div class="col-7">{{v.tcmc}}</div>
	</div>
	<div class="row mmt" v-show="v.tjsj">
		<div class="col-3">预约时间</div>
		<div class="col-7">{{v.yysj|strtotime}}</div>
	</div>
	<div class="row" v-show="v.tjsj">
		<div class="col-3">体检时间</div>
		<div class="col-7">{{v.tjsj|strtotime}}</div>
	</div>
	<div class="row bt" v-show="!v.tjsj" @click="goo(v)">
		<div class="col-9 blue">{{v.internetusertaocan=="True"&&v.tjsj==""?"选择套餐":"预约体检"}}</div>
		<div class="col-1"><i class="fa fa-angle-right"></i></div>
	</div>
</div>

<mt-actionsheet :actions="actions" v-model="showtc"></mt-actionsheet>

</div>
</template>

<style scoped>
.time{width:100vw;height:100vh;}
.center{color:rgb(0,144,255);margin:.5rem 0;}
.container{background: rgb(251,251,251);}
.pd{padding:2rem 1rem;}
.cal{margin-bottom:.5rem;float: left;}
.mint-button--default{height:2rem;margin-top:.4rem; }	
.gray{color:#adadad;}
.bb{border-bottom: 1px solid #eee;padding-bottom: .5rem;}
.pb{padding-bottom: .5rem;}
.bt{border-top:1px solid #eee;padding-top: .5rem;}
.myitem{border-radius: .3rem;background: white;padding:.5rem;
	float: left;width:96%;margin:2%;
	border:1px solid #eee;
}
.myitem i{font-size: 1.5rem;color:#ddd;float: right;margin-right:.5rem; }
.myitem .col-3{color:#adadad;}
.myitem .row{margin:.25rem .5rem;}
.myitem .mmt{margin-top: -0.5rem;}

</style>

<script>
import hos from "../../lib/hos.vue";
import cal from "../../lib/calendar.vue";

export default {
	components:{hos,cal},
	data:function(){
		return {
           f:{
           	hos:"",
           	name:"",
           	com:"",
           },
		   re:"",
		   showtc:false,
		   actions:[],
		   tem:"",
		}
	},
	filters:{
		strtotime:function(str){
			return str.substr(0,10);
		}
	},
	methods:{
		haha:function(d){
			this.f.hos=d;
		},
		search:function(){
			var _this=this;
			fun.post(mydata.apiuser+"getcom",this.f,function(d){
				if(d.status==1){
					_this.re=_this.order(d.info);
				}else{
					_this.$toast(d.info);
				}
			})
		},
		order:function(re){
			var n=[];
			for(var i=0;i<re.length;i++){
               if(re[i]['tjsj']==""){
               	n.unshift(re[i]);
               }else{
               	n.push(re[i]);
               }
			}
			return n;
		},
		goo:function(d){
			this.tem=d;
			this.tem.hos=this.f.hos;
			this.tem.com=this.f.com;
			if(!d.tjsj&&d.internetusertaocan=="True"){
				this.selectTc(d);return;
			}
			this.$emit("select",this.tem);
		},
		selectTc:function(data){
		  var _this=this;
		  fun.post(mydata.api+"Member/get_team_taocan",data,function(d){
			  console.log(d)
			  if(d.status==0){_this.$toast(d.info);return;}
			  _this.actions=[];
			  for(var i=0,len=d.info.length;i<len;i++){
				  if(d.info[i]['xb']==data.xb){
					    var tem={
							name:d.info[i]['mc'],
							wpid:d.info[i]['wpid'],
							method:_this.select,
						}
					     _this.actions.push(tem);
					  }
			  }
			  if(_this.actions.length>0){_this.showtc=true;}
		  })
		},
		select:function(d){
			this.tem.wpid=d.wpid;
			this.tem.tcmc=d.name;
			this.tem.internetusertaocan="True";
			//console.log(this.tem)
			this.$emit("select",this.tem);
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/team.vue